export default "__VITE_ASSET__g$0g0T3h__"